import {makePromise} from "./TemplateFunctions";
import {CameraCommandTypes} from "../../constans/mqttMessages";

export const openStream = makePromise(
    CameraCommandTypes.SET_CAMERA_RUN_STREAM,
    "null",
    ["DevID"],
    {showNotification: false}
);

export const closeStream = makePromise(
    CameraCommandTypes.SET_CAMERA_END_STREAM,
    "null",
    ["DevID"],
    {showNotification: false}
);
